import { Link } from 'react-router-dom';
import { Button, EmptyState } from '@playerbase/ui';

import { useShell } from '../use-shell.js';

export function NoGameEmptyState(): JSX.Element {
  const { activeStudio } = useShell();
  return (
    <EmptyState
      size="lg"
      eyebrow={activeStudio.name}
      title="Set up your first game"
      description="PlayerBase organises feedback, playtests, and milestones around a game. Add one to unlock the rest of the studio portal."
      cta={
        <Button asChild variant="primary" size="md">
          <Link to={`/s/${activeStudio.shortId}/games/new`}>Set up a game</Link>
        </Button>
      }
      footnote="Game configuration lives in Game Settings once your first game is created."
    />
  );
}
